/* ============================================
   Karunna — Teeinblue Gallery
   1) El dimensionado del slot y el loader viven en
      teeinblue-custom.css (aspect-ratio + alturas + aro
      acotado/oculto). Aquí solo:
   2) "nudge" de resize para que Teeinblue reajuste el
      mockup al slot estabilizado.
   3) MOBILE: calcula la escala para que el mockup llene
      el ancho (como la galería nativa) y la pasa al CSS
      como variables --krn-scale y --krn-slot-h. La escala
      depende de la proporción del mockup (varía por
      producto), por eso se mide en vivo. El artwork va
      dentro del mockup → escala junto y queda alineado.
   ============================================ */

(function () {
  'use strict';

  var MOBILE_BP = 768;

  function nudge() {
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  // Calcula --krn-scale / --krn-slot-h para el modo mobile.
  // offsetWidth/offsetHeight son inmunes al transform → sin bucle.
  function setMobileScale() {
    var wrap = document.querySelector('.tee-gallery-wrapper');
    var slider = document.querySelector('.tee-slider');
    if (!wrap || !slider) return;

    // Solo interesa en mobile; en desktop el @media ignora las vars.
    if (window.innerWidth > MOBILE_BP) {
      wrap.style.removeProperty('--krn-scale');
      wrap.style.removeProperty('--krn-slot-h');
      return;
    }

    var slide = document.querySelector('.tee-slide--active') ||
                document.querySelector('.tee-slide');
    var mk = slide && (slide.querySelector('.tee-mockup-image') ||
                       slide.querySelector('.tee-mockup'));
    if (!mk) return;

    var W = slider.clientWidth;
    var mw = mk.offsetWidth;
    var mh = mk.offsetHeight;
    if (!W || !mw || !mh) return;

    var scale = W / mw;
    var slotH = Math.round(mh * scale);

    wrap.style.setProperty('--krn-scale', scale.toFixed(4));
    wrap.style.setProperty('--krn-slot-h', slotH + 'px');
  }

  var t;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(setMobileScale, 60);
  }

  function init() {
    var gallery = document.querySelector('.tee-gallery');
    if (!gallery) { setTimeout(init, 250); return; }

    nudge();
    setMobileScale();
    setTimeout(function () { nudge(); setMobileScale(); }, 500);
    setTimeout(function () { nudge(); setMobileScale(); }, 1500);

    // Recalcular al cambiar variante / slide / cargar imágenes.
    var obs = new MutationObserver(refresh);
    obs.observe(gallery, { attributes: true, childList: true, subtree: true,
                           attributeFilter: ['class', 'style', 'src'] });

    window.addEventListener('resize', refresh);
    window.addEventListener('orientationchange', function () {
      setTimeout(setMobileScale, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    setTimeout(function () { nudge(); setMobileScale(); }, 300);
  });
})();

/* ============================================
   Karunna — Multi-carga de fotos en carrusel horizontal
   Cuando un producto Teeinblue tiene 2+ campos de foto CONTIGUOS
   (.tee-field--photo, p.ej. collage), los envuelve en
   .krn-photo-carousel para que se muestren en una fila deslizable
   (estilo en teeinblue-custom.css) en vez de apilados. Un solo
   campo de foto no se envuelve. Es idempotente y se re-aplica
   cuando Teeinblue re-renderiza el formulario (cambio de variante
   o plantilla), vía MutationObserver.
   ============================================ */
(function () {
  'use strict';

  var WRAP = 'krn-photo-carousel';
  var busy = false;

  // Agrupa campos de foto por (mismo padre + contigüidad).
  // Ignora los que viven en plantillas ocultas o ya envueltos.
  function groupRuns() {
    var photos = [].slice.call(document.querySelectorAll('.tee-field--photo'))
      .filter(function (p) {
        return !p.closest('.sr-only') &&
               !p.closest('.tee-field--template') &&
               !p.closest('.' + WRAP);
      });
    var runs = [], cur = null;
    photos.forEach(function (p) {
      var parent = p.parentElement;
      var prev = p.previousElementSibling;
      if (cur && cur.parent === parent && prev &&
          cur.items[cur.items.length - 1] === prev) {
        cur.items.push(p);
      } else {
        cur = { parent: parent, items: [p] };
        runs.push(cur);
      }
    });
    return runs.filter(function (r) { return r.items.length >= 2; });
  }

  function apply() {
    if (busy) return;
    var runs = groupRuns();
    if (!runs.length) return;
    busy = true;
    try {
      runs.forEach(function (r) {
        var wrap = document.createElement('div');
        wrap.className = WRAP;
        r.parent.insertBefore(wrap, r.items[0]);
        r.items.forEach(function (p) { wrap.appendChild(p); });
      });
    } finally {
      // Liberar tras el ciclo de microtareas de mutación.
      setTimeout(function () { busy = false; }, 0);
    }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(apply, 120); }

  function init() {
    apply();
    var obs = new MutationObserver(function (muts) {
      if (busy) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', function () {
      setTimeout(apply, 300);
      setTimeout(apply, 1200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
